import { useBrokerDetailsStore, FormField } from '../../../state/brokerDetailsStore';
import { useBrokerFieldFieldChanged } from '../../../hooks/useBrokerFieldChanged';
import { ZipCodeBox } from '@apply/components';
import { ShowIf } from '@apply/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const ZipCodeField = () => {
    const value = useBrokerDetailsStore((s) => s.homeAddress.zipCode);
    const updateHomeAddress = useBrokerDetailsStore((s) => s.updateHomeAddress);
    const isBroker = useBrokerDetailsStore((s) => s.isBroker);
    const changed = useBrokerFieldFieldChanged(FormField.HomeZipCode);
    return (
        <>
            <ZipCodeBox
                id='hZipCode'
                value={value}
                onChange={(v) => updateHomeAddress({ zipCode: v })}
                label='Zip Code'
                required={isBroker}
                width={'100%'}
                placeholder='Zip code, 5 or 9 digit'
            />
            <ShowIf showIf={changed}>
                <FontAwesomeIcon
                    icon={'asterisk'}
                    className='required-icon'
                />
            </ShowIf>
        </>
    );
};
